import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import CPFInput from '../../ui/form/CPFInput'
import DocNumInput from '../../ui/form/DocNumInput'

class DocFields extends Component {
  state = {
    hasCpf: this.props.values.docNum ? false : true,
  }

  handleChange = (hasCpf) => () => {
    this.setState({
      hasCpf,
    })

    if (!this.props.isEditing) {
      if (hasCpf) {
        this.props.form.change('docNum', undefined)
      } else {
        this.props.form.change('cpf', undefined)
      }
    }
  }

  render() {
    return (
      <>
        <label className="label">Possui CPF?</label>
        <div className="buttons has-addons">
          <span
            className={classNames('button', {
              'is-info is-selected': this.state.hasCpf,
            })}
            onClick={this.handleChange(true)}
          >
            Sim
          </span>
          <span
            className={classNames('button', {
              'is-info is-selected': !this.state.hasCpf,
            })}
            onClick={this.handleChange(false)}
          >
            Não
          </span>
        </div>

        {this.state.hasCpf ? (
          <CPFInput
            name="cpf"
            label="CPF"
            checkAvailability={!this.props.isEditing}
          />
        ) : (
          <DocNumInput
            name="docNum"
            label="Documento de identificação"
            checkAvailability={!this.props.isEditing}
            autoComplete="off"
          />
        )}
      </>
    )
  }
}

DocFields.propTypes = {
  values: PropTypes.object,
}

DocFields.defaultProps = {
  values: {},
}

export default DocFields
